import { collection, getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: FIREBASE_CONFIG_ENV === "production"
        ? "AIzaSyDtIcOw6J3So1xElUbjY2XFLUPm4tL37do-5ZBYYdY"
        : FIREBASE_CONFIG_ENV === "test"
            ? "AIzaSyBjxynhn90su0nXYaAPheRtdEqWE3agJDI"
            : "AIzaSyBqdp5XBbU7N-Uq9AR6IujeeERnb4AaJnk",
    authDomain: FIREBASE_CONFIG_ENV === "production" ? "sin-expon-prod.firebaseapp.com" : FIREBASE_CONFIG_ENV === "test" ? "sin-expon-stg.firebaseapp.com" : "sin-expon.firebaseapp.com",
    projectId: FIREBASE_CONFIG_ENV === "production" ? "sin-expon-prod" : FIREBASE_CONFIG_ENV === "test" ? "sin-expon-stg" : "sin-expon",
    storageBucket: FIREBASE_CONFIG_ENV === "production" ? "sin-expon-prod.appspot.com" : FIREBASE_CONFIG_ENV === "test" ? "sin-expon-stg.appspot.com" : "sin-expon.appspot.com",
    messagingSenderId: FIREBASE_CONFIG_ENV === "production" ? "797916031110" : FIREBASE_CONFIG_ENV === "test" ? "298758560502" : "1049444085667",
    appId: FIREBASE_CONFIG_ENV === "production"
        ? "1:797916031110:web:6538f56c8f088f2d05c907"
        : FIREBASE_CONFIG_ENV === "test"
            ? "1:298758560502:web:5a43e6b4f351cb139fead7"
            : "1:1049444085667:web:32b0f19f8145b4f112f416",
};
// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseStore = getFirestore(firebaseApp);
export const messagesRef = collection(firebaseStore, "messages");
